export default {"src":"/_next/static/media/0x493257fd37edb34451f62edf8d2a0c418852ba4c.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};